import * as Constants from '../../../constants'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

const defaultBorder = 'rgba(255, 255, 255, 0.15)'
const hoverBorder = 'rgba(255, 255, 255, 0.3)'

const MetricaGreenTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: Constants.theme.palette.text.main
    },
    '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      transform: 'translate(14px, 15px) scale(1)'
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: defaultBorder
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: `${hoverBorder} !important`
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'var(--metrica-green)'
    },
    '& .MuiFilledInput-underline:before': {
      borderBottomColor: defaultBorder
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': {
        borderColor: defaultBorder
      },
      '&:hover fieldset': {
        borderColor: hoverBorder
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--metrica-green)'
      }
    },
    '& input:-webkit-autofill': {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    }
  }
})(TextField)

export default MetricaGreenTextField
